import React from 'react';
import { HOME_FAQ } from '../../data/homeContent';
import { SectionHeading } from '../ui/SectionHeading';
import { FaqList } from '../ui/FaqList';
export function HomeFaq() {
  return <section id="faq" aria-labelledby="faq-heading" className="scroll-mt-20 border-b border-hairline-soft bg-ink" data-id="element-143" data-mp="1tgv64oww1z4v">
      <div className="mx-auto w-full max-w-[900px] px-4 py-20 sm:px-6 lg:px-8 lg:py-24" data-id="element-144" data-mp="1yfybkags67dd">
        <SectionHeading eyebrow="FAQ" headingId="faq-heading" title="Questions investment teams ask." data-id="element-145" data-mp="10sg370r1779w" />
        <div className="mt-10" data-id="element-146" data-mp="15qhmnmsdd8lw">
          <FaqList items={HOME_FAQ} data-id="element-147" data-mp="15rixpr9dxv3m" />
        </div>
      </div>
    </section>;
}